module.exports = __webpack_public_path__ + "static/media/flyerW.80cbd331.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/flyerW.svg
// module id = 546
// module chunks = 0